import React from "react"
import clsx from "clsx"
import {CheckCircleIcon} from "@heroicons/react/20/solid"

import {StepStatusTypeExt} from "./useStep"

const StepStatusComp: Record<StepStatusTypeExt, {
    textColor: string,
    icon?: React.ReactNode
}> = {
    incomplete: {
        textColor: "text-gray-500 group-hover:text-gray-900",
        icon: <div
            className="h-2 w-2 rounded-full bg-gray-300 group-hover:bg-gray-400"/>
    },
    active: {
        textColor: "text-indigo-600",
        icon: <>
            <span className="absolute h-4 w-4 rounded-full bg-indigo-200"/>
            <span className="relative block h-2 w-2 rounded-full bg-indigo-600"/>
        </>
    },
    complete: {
        textColor: "text-gray-500 group-hover:text-gray-900",
        icon: <CheckCircleIcon
            className="h-full w-full text-indigo-600 group-hover:text-indigo-800"
            aria-hidden="true"
        />
    },
    error: {
        textColor: "text-red-600",
        icon: <>
            <span className="absolute h-4 w-4 rounded-full bg-red-200"/>
            <span className="relative block h-2 w-2 rounded-full bg-red-600"/>
        </>
    }
}

type StepProps = {
    title: string,
    stepStatus: StepStatusTypeExt,
    onClick: () => void
}


export function VerticalSteps({title, stepStatus, onClick}: StepProps) {
    return <a className="cursor-pointer group" onClick={onClick}>
        <div className="flex items-start">
            <div
                className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
                aria-hidden="true">
                {StepStatusComp[stepStatus].icon}
            </div>
            <span className={clsx("ml-3 text-sm font-medium", StepStatusComp[stepStatus].textColor)}>
                      {title}
             </span>
        </div>
    </a>
}